import React from "react";
import "./LoadingCircleSmall.css";

const LoadingCircleSmall = ({ label, showLabel = false }) => {
  return (
    <div className="loading-container-small">
      <div className="loading-spinner"></div>
      {showLabel && label && <div className="loading-label">{label}</div>}
    </div>
  );
};

export default LoadingCircleSmall;
